module.exports = __webpack_public_path__ + "static/media/crab.4baa5277.svg";